import styled from 'styled-components';

export const CarouselBackdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.8);
	z-index: 10000;
	display: flex;
	justify-content: center;
	align-items: center;

	&:fullscreen {
		background-color: #000;
		padding: 0;
		margin: 0;

		img {
			max-height: 100vh;
			max-width: 100vw;
		}
	}
`;

// Fixed-height frame: dynamicHeight measures the PRE-transform slide
// height and crops 90/270-rotated images; fixed 80vh column, centered.
export const CarouselContent = styled.div`
	position: relative;
	z-index: 10001;
	max-width: 100vw;
	display: flex; 
	align-items: center; 
	justify-content: center; 
	background: transparent;
	.carousel .control-arrow {
		width: 8vw;
	}

	.carousel-root,
	.carousel-root .carousel,
	.carousel-root .carousel .slider-wrapper {
		height: 80vh;
	}

	.carousel-root li.slide {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.carousel .control-prev {
		left: 0;
	}

	.carousel .control-next {
		right: 0;
	}

	img {
		max-height: 80vh;
		max-width: 80vw;
		object-fit: contain;
		display: block;
		margin: 0 auto;
	}
`;

// Custom Arrow Buttons
export const CustomArrowButton = styled.button`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	z-index: 2;
	background: rgba(0, 0, 0, 0.4);
	color: white;
	border: none;
	padding: 25px 15px;
	cursor: pointer;
	font-size: 36px;
	line-height: 1;
	transition: background 0.2s ease;
	border-radius: 4px;

	&:hover {
		background: rgba(0, 0, 0, 0.7);
	}

	&:disabled {
		opacity: 0.3;
		cursor: default;
	}

	@media (max-width: 768px) {
		padding: 15px 10px; 
		font-size: 28px; 
	}
`;

export const CustomPrevButton = styled(CustomArrowButton)`
	left: 10px; 
`;

export const CustomNextButton = styled(CustomArrowButton)`
	right: 10px; 
`;

export const MediaContainer = styled.div`
	display: flex; 
	justify-content: center;
	align-items: center;
	max-width: 100%;
	max-height: 100%;
	video {
		width: 100%;
		height: 100%;
		background-color: black;
	}
`;

export const VideoPlaceholder = styled.a<{
	$thumbnailUrl: string;
	$aspectRatio: number;
}>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: relative; 
	aspect-ratio: ${(props) => props.$aspectRatio}; 
	max-width: 95vw; 
	max-height: 95vh; 
	width: auto; 
	height: auto; 
	margin: auto; 
	background-image: ${(props) =>
		`url(${props.$thumbnailUrl})`}; 
	background-size: contain; 
	background-position: center;
	background-repeat: no-repeat;
	background-color: #111; 
	color: #fff; 
	text-decoration: none;
	border-radius: 4px; 
	cursor: pointer;
	overflow: hidden; 

	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(
			0,
			0,
			0,
			0.5
		); 
		transition: background-color 0.2s ease;
		z-index: 1; 
	}

	&:hover::after {
		background-color: rgba(0, 0, 0, 0.7); 
	}

	&::before {
		content: '▶'; 
		font-size: 5rem; 
		margin-bottom: 1rem;
		color: #fff; 
		text-shadow: 0 0 8px rgba(0, 0, 0, 0.8); 
		z-index: 2; 
		position: relative; 
	}

	span {
		font-size: 1.2rem;
		text-align: center;
		padding: 0 1rem;
		color: #fff; 
		text-shadow: 0 0 5px rgba(0, 0, 0, 0.7); 
		z-index: 2; 
		position: relative; 
	}
`;

export const DownloadButton = styled.button`
	background: none;
	border: none;
	color: #fff;
	cursor: pointer;
	padding: 4px 8px;
	font-size: 16px;
	opacity: 0.8;
	transition: opacity 0.2s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	&:hover {
		opacity: 1;
	}

	@media (max-width: 768px) {
		font-size: 14px;
		padding: 4px 6px;
	}
`;

export const DownloadModalBackdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 10002;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const DownloadModalCard = styled.div`
	background: rgba(30, 30, 30, 0.95);
	color: #eee;
	border-radius: 10px;
	padding: 16px;
	max-width: 240px;
	width: calc(100vw - 40px);
	display: flex;
	flex-direction: column;
	gap: 0;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const DownloadModalTitle = styled.div`
	margin: 0 0 8px 0;
	font-size: 0.85rem;
	color: #aaa;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	text-align: center;
`;

export const DownloadRow = styled.button`
	background: none;
	border: none;
	border-top: 1px solid rgba(255, 255, 255, 0.08);
	padding: 12px 8px;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #eee;
	font-size: 0.95rem;
	transition: background 0.15s ease;
	width: 100%;

	&:first-of-type {
		border-top: none;
	}

	&:hover {
		background: rgba(255, 255, 255, 0.08);
	}

	&:focus-visible {
		outline: 2px solid #4a9eff;
		outline-offset: -2px;
	}
`;

export const DownloadLabel = styled.span`
	font-weight: 500;
`;

export const DownloadSize = styled.span`
	color: #999;
	font-size: 0.85rem;
`;

export const CarouselImageLegend = styled.div`

	&& {

		visibility: visible;
		background: rgba(0, 0, 0, 0.6);
		color: #fff;
		border-radius: 20px; 
		padding: 8px 16px;
		font-size: 14px;
		opacity: 1; 
		display: flex !important;
		align-items: center;
		gap: 12px;

		position: absolute !important;
		bottom: 30px !important;
		left: 50% !important;
		transform: translateX(-50%) !important;
		margin-left: 0 !important;
		right: auto !important;

		width: max-content !important; 
		max-width: 90vw !important; 
		min-width: 0 !important; 

		line-height: 1.4;
		text-align: center;
		white-space: normal; 
	}
`;
